import HttpRequest from '../request'
import { LegacyEnterpriseApi } from '../api'
import type { Response } from '../request'
import type {
  LegacyBindConfirmRequest,
  LegacyBindIssueRequest,
  LegacyExecuteRequest,
  LegacyExecution,
  LegacyIdentityChallenge,
  LegacyPreflightResult,
  LegacyState,
} from './ownerTypes'

export default {
  state: (): Promise<Response<LegacyState>> => HttpRequest.get(LegacyEnterpriseApi.state, {}),
  begin: (): Promise<Response<LegacyState>> => HttpRequest.post(LegacyEnterpriseApi.begin, {}),
  preflight: (migrationNo: string): Promise<Response<LegacyPreflightResult>> =>
    HttpRequest.post(LegacyEnterpriseApi.preflight, { migrationNo }),
  execute: (request: LegacyExecuteRequest): Promise<Response<LegacyExecution>> =>
    HttpRequest.post(LegacyEnterpriseApi.execute, request),
  execution: (migrationNo: string): Promise<Response<LegacyExecution>> =>
    HttpRequest.get(LegacyEnterpriseApi.execution, { migrationNo }),
  cancelWaiting: (migrationNo: string): Promise<Response<boolean>> =>
    HttpRequest.post(LegacyEnterpriseApi.cancelWaiting, { migrationNo }),
  bindIssue: (request: LegacyBindIssueRequest): Promise<Response<LegacyIdentityChallenge>> =>
    HttpRequest.post(LegacyEnterpriseApi.bindIssue, request),
  bindConfirm: (request: LegacyBindConfirmRequest): Promise<Response<string>> =>
    HttpRequest.post(LegacyEnterpriseApi.bindConfirm, request),
}
